module.exports = __webpack_public_path__ + "img/curve_sm.b6b99d6e.svg";